export enum InvoiceTab {
  OWN = 'own',
  FOREIGN = 'foreign',
  ADMINISTRATIVE = 'administrative',
  INTERNAL = 'internal',
}

export enum RatesTab {
  OWN = 'own',
}

export enum RatesType {
  RATES = 'rates',
}

export enum TransportCloudTab {}

export enum InvoiceType {
  INVOICE = 'invoice',
  CORRECTIVE_INVOICE = 'correctiveinvoice',
}

export enum ReportsTab {
  ACTIVITIES = 'activities',
  ACTIVITY = 'activity',
  CONTAINER = 'container',
  INVOICE = 'invoice',
  OFFER = 'offer',
  JOBS = 'jobs',
  FORECAST = 'forecast',
  OCEAN_SCHEDULES = 'oceanSchedules',
}

export enum FilesTab {
  COUNTERPARTIES = 'counterparties',
  CUSTOMERS = 'customers',
  SHIPPING_LINES = 'shippinglines',
  TRUCKERS = 'truckers',
  TERMINALS = 'terminals',
  DEPOTS = 'depots',
  AGENTS = 'agents',
  CUSTOMS_AGENCIES = 'customsagencies',
  INSURERS = 'insurers',
  OTHERS = 'others',
}

export enum TableTab {
  CURRENCIES = 'currencies',
  UNITS = 'units',
  TAX_RATES = 'taxrates',
  ACTIVITIES = 'activities',
  PORTS = 'ports',
  PRODUCT_GROUPS = 'productgroups',
  CONTAINER_SIZE = 'containerSizes',
  CONTAINER_TYPE = 'containerTypes',
  CONTAINERS = 'containers',
  PACKAGES = 'packages',
  INVOICE_CLASSES = 'invoiceClasses',
  DISTANCES = 'distances',
  CLAUSES = 'clauses',
  ITEM_CONFIGURATIONS = 'itemConfigurations',
  REGIONS = 'regions',
  FORECASTS = 'forecasts',
  TRANSPORT_MODES = 'transportModes',
  EDI_PARTIES = 'ediParties',
  INTTRA_SUPPORTED_LINES = 'inttraSupportedLines',
}

export enum PricesTab {
  TERMINAL_PRICES = 'terminalprices',
  CUSTOMS_AGENCY_PRICES = 'customsagencyprices',
  TRANSPORT_RATES = 'transportrates',
  EXCHANGE_RATES = 'exchangerates',
}

export enum EventsTab {
  CALENDAR = 'calendar',
  ACTIVITY_LIST = 'activityList',
}

export enum AdminTab {
  GROUPS = 'groups',
  ROLES = 'roles',
  BRANCHES = 'branches',
  USERS = 'users',
  PARAMETERS = 'parameters',
  JPK = 'jpk',
  PRIMARY_COUNTERPARTY_DATA = 'primaryCounterpartyData',
  SERVICE_TERMS = 'serviceTerms',
}

export enum SettingsTab {
  BCT = 'activityMappingBCT',
  CMA = 'activityMappingCMA',
  GCT = 'activityMappingGCT',
  MAERSK = 'activityMappingMAERSK',
}
